import { render, staticRenderFns } from "./Exemption.vue?vue&type=template&id=0c950173&"
import script from "./Exemption.vue?vue&type=script&lang=js&"
export * from "./Exemption.vue?vue&type=script&lang=js&"
import style0 from "./Exemption.vue?vue&type=style&index=0&id=0c950173&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports